<template>
    <div>
        <SalesReportTemplate
            title="Skipping Report"
            :columns="columns"
            fetchRoute="/reports/skipping-report"
            reportTypeCode="SKIPPING_REPORT"
            permission="CMS_VIEW_REPORT_SKIPPING_REPORT"
            @onResponse="handleResponse"
        >
            <template #filters>
                <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                    <!-- Employee Filter -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">Employee</label>
                        <select 
                            v-model="selectedEmployee" 
                            class="w-full border border-gray-300 rounded-md px-3 py-2"
                            @change="updateFilters"
                        >
                            <option value="">All Employees</option>
                            <option v-for="employee in employees" :key="employee.id" :value="employee.id">
                                {{ employee.name }}
                            </option>
                        </select>
                    </div>
                    
                    <!-- Product Filter -->
                    <div>
                        <label class="block text-sm font-medium text-gray-700 mb-2">Product</label>
                        <select 
                            v-model="selectedProduct" 
                            class="w-full border border-gray-300 rounded-md px-3 py-2"
                            @change="updateFilters"
                        >
                            <option value="">All Products</option>
                            <option v-for="product in products" :key="product.id" :value="product.id">
                                {{ product.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </template>
        </SalesReportTemplate>
    </div>
</template>

<script>
import SalesReportTemplate from './SalesReportTemplate.vue'
import { mapState } from 'vuex'
import { http } from '@/utils/http'

export default {
    name: 'SkippingReport',
    components: {
        SalesReportTemplate
    },
    data() {
        return {
            selectedEmployee: '',
            selectedProduct: '',
            employees: [],
            products: [],
            columns: [
                { key: 'formattedDate', title: 'Date' },
                { key: 'item_code', title: 'Item Code' },
                { key: 'item_name', title: 'Item Name' },
                { key: 'qty', title: 'Quantity' },
                { key: 'rate', title: 'Original Price' },
                { key: 'skipped_at', title: 'Skipped At' },
                { key: 'skipped_by_user_name', title: 'Skipped By' },
                { key: 'skip_reason', title: 'Skip Reason' },
                { key: 'warehouse_name', title: 'Location' },
            ]
        }
    },
    computed: {
        ...mapState('misc', ['warehouses'])
    },
    mounted() {
        this.loadEmployees()
        this.loadProducts()
    },
    methods: {
        async loadEmployees() {
            try {
                const response = await http.get('/users')
                this.employees = response.data.result || []
            } catch (error) {
                console.error('Error loading employees:', error)
            }
        },
        async loadProducts() {
            try {
                const response = await http.get('/items')
                this.products = response.data.result || []
            } catch (error) {
                console.error('Error loading products:', error)
            }
        },
        updateFilters() {
            // Emit filter changes to parent component
            this.$emit('filtersChanged', {
                employee_user_ids: this.selectedEmployee,
                product_ids: this.selectedProduct
            })
        },
        handleResponse(data) {
            // Handle response data if needed
            console.log('Skipping report data:', data)
        }
    }
}
</script>

<style scoped>
/* Add any custom styles here */
</style> 